module.exports = __webpack_public_path__ + "static/img/N-Nuvolos-blue.daec9939.svg";